const {$, $$} = window // eslint-disable-line

import DestroyGallery from './destroyGallery'

export function initMembershipFees(elem) {
  let contentWrapper = $$('.membership-fees__content-wrapper')
  contentWrapper.forEach(content => {
    if (content.children.length > 1) {
      content.classList.add('border')
    }
  })

  let mql = window.matchMedia('(max-width: 800px)'),
    membershipGallery = null

  if (mql.matches) {
    membershipGallery = new DestroyGallery(elem, {
      visibleSlides: 1.2,
      autoPlay: false,
    })
    membershipGallery.reveal(1)
  }

  let screenTest = function(e) {
    if (e.matches) {
      membershipGallery = new DestroyGallery($('.membership-fees'), {
        visibleSlides: 1.2,
        autoPlay: false,
      })
      membershipGallery.reveal(1)
    } else {
      if (membershipGallery != null) {
        membershipGallery.destroy()
        membershipGallery = null
      }
    }
  }

  mql.addListener(screenTest)
  if ($('.enter_details')) {
    let chooseButtons = $$('.membership-fees__signin button')
    let urlPlan = window.location.search.substr(6, 12)
    chooseButtons.forEach(chooseButton => {
      let buttonData = chooseButton.dataset.plan
      if (urlPlan == buttonData) {
        chooseButton.classList.add('active')
        chooseButton.innerHTML = 'Ausgewählt'
      }
      chooseButton.addEventListener('click', function(e) {
        e.preventDefault()
        if (!chooseButton.classList.contains('active')) {
          $('.membership-fees__signin button').innerHTML = 'Auswählen'
          $('.membership-fees__signin button').parentElement.classList.remove(
            'active'
          )
          $('.membership-fees__signin button.active').classList.remove('active')
          chooseButton.parentElement.classList.add('active')
          chooseButton.classList.add('active')
          chooseButton.innerHTML = 'Ausgewählt'
          let newPlan = (window.location.search =
            '?plan=' + $('.membership-fees__signin button.active').dataset.plan)
          window.history.replaceState({id: buttonData}, null, newPlan)
        }
      })
    })
  }
}

export function initPayment() {
  let plans = {
    kollegin: {month: 5, year: 60},
    fruendin: {month: 10, year: 120},
    insiderin: {month: 15, year: 180},
  }

  let planKey = window.location.search.match(/plan=(\w+?)\b/),
    plan = plans[planKey && planKey[1]] || plans.kollegin

  let monthWrapper = $('.payment-and-donation__wrapper-month')
  let yearWrapper = $('.payment-and-donation__wrapper-year')

  let monthAmountInput = $('.payment-and-donation__amount', monthWrapper)
  let yearAmountInput = $('.payment-and-donation__amount', yearWrapper)
  let renewAutomaticallyInput = $('#renew-automatically')

  monthAmountInput.value = plan.month
  yearAmountInput.value = plan.year

  // Arrow up and down
  $$('.payment-and-donation__amount-up')._.addEventListener(
    'click',
    function() {
      let input = $('input', this.parentNode)
      input.value = 1 + parseInt(input.value, 10)
    }
  )
  $$('.payment-and-donation__amount-down')._.addEventListener(
    'click',
    function() {
      let input = $('input', this.parentNode)
      input.value = Math.max(
        parseInt(input.min, 10),
        -1 + parseInt(input.value, 10)
      )
    }
  )

  // Select periodicity
  $$('.payment-and-donation__select')._.addEventListener('click', function() {
    let wrapper = this.closest('.payment-and-donation__wrapper'),
      current = this.closest('[data-periodicity]')

    Array.from(wrapper.children).forEach(child => {
      let active = current == child
      child.classList[active ? 'add' : 'remove']('active')
      $('.payment-and-donation__select', child).innerHTML = active
        ? 'Ausgewählt'
        : 'Auswählen'
    })

    if (current.dataset.periodicity == 'monthly') {
      renewAutomaticallyInput.checked = true
      renewAutomaticallyInput.disabled = true
      const payment_option = $('.payment-option__visa-master-wrapper')
      if (payment_option) {
        payment_option.click()
      }
    } else {
      renewAutomaticallyInput.disabled = false
    }
    const allowedPaymentMethods =
      current.getAttribute('data-periodicity') === 'monthly'
        ? ['stripe']
        : ['stripe', 'postfinance', 'banktransfer']
    $$('.payment-option').forEach(el => {
      el.style.pointerEvents = allowedPaymentMethods.includes(
        el.getAttribute('data-method')
      )
        ? 'auto'
        : 'none'
    })
  })

  // Select payment method
  $$('.payment-option')._.addEventListener('click', e => {
    $$('.payment-option').forEach(el =>
      el.classList.remove('payment-option__active')
    )
    let opt = e.target.closest('[data-method]')
    opt.classList.add('payment-option__active')

    $('.payment-option__stripe').classList[
      opt.dataset.method == 'stripe' ? 'remove' : 'add'
    ]('hidden')
  })

  $(
    '.payment-and-donation__wrapper-month .payment-and-donation__select'
  ).click()

  initStripe()
}

function addFields(form, formData) {
  let periodicity = $('[data-periodicity].active')

  formData.append('periodicity', periodicity.dataset.periodicity)
  formData.append('amount', $('input', periodicity).value)
  formData.append(
    'payment_method',
    'stripe'
    // $('[data-method].payment-option__active').dataset.method
  )
}

function initStripe() {
  let form = $('#card-form')
  if (!form) return

  const style = {
    base: {
      color: '#32325d',
      lineHeight: '24px',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a',
    },
  }

  const stripe = window.Stripe(form.dataset.publishableKey),
    elements = stripe.elements()

  let card = elements.create('card', {style: style, hidePostalCode: true})
  card.mount('#card-element')
  card.addEventListener('change', function(event) {
    document.getElementById('card-errors').textContent = event.error
      ? event.error.message
      : '\u00A0'
  })

  form.addEventListener('submit', e => {
    e.preventDefault()

    let fd = new FormData(form)
    addFields(form, fd)

    if (fd.get('payment_method') == 'stripe') {
      stripe.createToken(card).then(result => {
        if (result.error) {
          $('#card-errors').textContent = result.error.message
        } else {
          fd.append('token', result.token.id)
          $.fetch(form.dataset.subscribe, {
            method: 'POST',
            data: fd,
            headers: {
              'content-type': undefined,
            },
          }).then(() => {
            trackRegistration(fd.get('plan'), fd.get('amount'))
            window.location.href = '/accounts/'
          })
        }
      })
    } else {
      $.fetch(form.action, {
        method: 'POST',
        data: fd,
        headers: {
          'content-type': undefined,
        },
      }).then(response => {
        trackRegistration(fd.get('plan'), fd.get('amount'))

        $('section.member-area').innerHTML =
          '<div class="row align-center">' +
          '<div class="small-12 medium-6 columns">' +
          '<h2>Du wirst gleich weitergeleitet</h2>' +
          '</div> </div>' +
          response.responseText

        $('section.member-area form').submit()
      })
    }
  })
}

function trackRegistration(plan, amount) {
  if (window.dataLayer) {
    try {
      window.dataLayer.push({
        event: 'registration',
        plan: plan,
        amount: amount,
      })
    } catch (err) {
      window.console.error('dataLayer push failed', err)
    }
  }
}
